import React from 'react'
import Footer from '../components/Footer'

const Services = () => {
  return (
    <>
    
     <div>
      <section className="container my-5">
        <div className="text-center mb-5">
          <h2 className="fw-bold text-primary">हमारी डेंटल सेवाएँ</h2>
          <p className="text-muted">
            Natural Tooth द्वारा उपलब्ध प्रमुख दंत चिकित्सा सेवाएँ
          </p>
        </div>

        <div className="row g-4">
          {/* Facility 1 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">RCT</h5>
                <p className="card-text">
                  • दर्द रहित रूट कैनाल थेरेपी<br />
                  • एक या अधिक सिटिंग में उपचार
                </p>
              </div>
            </div>
          </div>

          {/* Facility 2 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Dental Implants</h5>
                <p className="card-text">
                  • स्थायी दाँत प्रत्यारोपण<br />
                  • उन्नत इम्प्लांट तकनीक
                </p>
              </div>
            </div>
          </div>

          {/* Facility 3 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Scaling</h5>
                <p className="card-text">
                  • टार्टर हटाना<br />
                  • मसूड़ों की सफाई
                </p>
              </div>
            </div>
          </div>

          {/* Facility 4 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Braces</h5>
                <p className="card-text">
                  • टेढ़े-मेढ़े दाँतों का इलाज<br />
                  • बच्चों और वयस्कों के लिए
                </p>
              </div>
            </div>
          </div>

          {/* Facility 5 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Smile Designing</h5>
                <p className="card-text">
                  • सुरक्षित और प्रभावी ब्लीचिंग<br />
                  • कॉस्मेटिक डेंटल उपचार
                </p>
              </div>
            </div>
          </div>

          {/* Facility 6 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Zirconia Crown & Bridge</h5>
                <p className="card-text">
                  • खोए हुए दाँतों की भरपाई<br />
                  • उच्च गुणवत्ता वाले ज़िरकोनिया विकल्प
                </p>
              </div>
            </div>
          </div>

          {/* Facility 7 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Titanium Crown & Bridge</h5>
                <p className="card-text">
                  • खोए हुए दाँतों की भरपाई<br />
                  • टिकाऊ टाइटेनियम सामग्री
                </p>
              </div>
            </div>
          </div>

          {/* Facility 8 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">Metal-Free Crown & Bridge</h5>
                <p className="card-text">
                  • खोए हुए दाँतों की भरपाई<br />
                  • सौंदर्यपूर्ण धातु-मुक्त विकल्प
                </p>
              </div>
            </div>
          </div>

          {/* Facility 9 */}
          <div className="col-md-4">
            <div className="card facility-card h-100">
              <div className="card-body">
                <h5 className="card-title">MRI-Free Crown & Bridge</h5>
                <p className="card-text">
                  • खोए हुए दाँतों की भरपाई<br />
                  • एमआरआई-सुरक्षित सामग्री
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mt-4">
          <p className="text-muted fw-bold">
            Best quality treatment at affordable prices
          </p>
        </div>
      </section>

      <style jsx>{`
        .facility-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
          transition: 0.3s ease-in-out;
        }
      `}</style>
    </div>
    <Footer/>
    </>
  )
}

export default Services
